export const headerHeight = 52
export const heroPadding = 40
export const componentsGap = 40
